import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Spinner, Alert } from "react-bootstrap";
import TableComponent from "../../components/TableComponent";
import { formatDate } from "../../utils/helpers";

const API_URL = process.env.REACT_APP_API_URL;

function LogList() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await axios.get(`${API_URL}/logs`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLogs(res.data.logs || []);
    } catch (err) {
      console.error(err);
      setError("Failed to load activity logs");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { key: "index", label: "Sr.No", format: (_, __, index) => index + 1 },
    { key: "username", label: "User" },
    { key: "action", label: "Action" },
    { key: "details", label: "Details" },
    { key: "created_at", label: "Date", format: formatDate },
  ];

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Activity Logs</h3>
      </div>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      )}

      {error && <Alert variant="danger">{error}</Alert>}

      {!loading && !error && (
        <TableComponent
          columns={columns}
          data={logs}
          rowsPerPage={logs.length}
          maxHeight={400}   // 👈 SAME AS USER LIST
        />
      )}
    </Container>
  );
}

export default LogList;
